import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './FAQ.css';

const FAQ = () => {
  const location = useLocation();

  return (
    <div className="faq-container">
      <div className="faq-window win98-bevel">
        <div className="navigation-bar win98-bevel-inset">
          <div className="nav-links">
            <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>
              💬 Chat
            </Link>
            <Link to="/pool" className={`nav-link ${location.pathname === '/pool' ? 'active' : ''}`}>
              💎 Pool
            </Link>
            <Link to="/leaderboard" className={`nav-link ${location.pathname === '/leaderboard' ? 'active' : ''}`}>
              🏆 Leaderboard
            </Link>
            <Link to="/settings" className={`nav-link ${location.pathname === '/settings' ? 'active' : ''}`}>
              ⚙️ Settings
            </Link>
            <Link to="/faq" className={`nav-link ${location.pathname === '/faq' ? 'active' : ''}`}>
              ❓ FAQ
            </Link>
            <Link to="/tos" className={`nav-link ${location.pathname === '/tos' ? 'active' : ''}`}>
              📜 Rules/ToS
            </Link>
            <a 
              href="https://discord.gg/B26JbHZsqq" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="nav-link discord-link"
              title="Join our Discord"
              style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
            >
              <svg width="16" height="16" viewBox="0 0 71 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0824 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0824 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 49.9718 48.5383C51.038 50.6034 52.2554 52.5699 53.5951 54.435C53.651 54.5139 53.7489 54.5477 53.8413 54.5195C59.646 52.7249 65.5286 50.0174 71.6015 45.5576C71.6551 45.5182 71.6887 45.459 71.6943 45.3942C73.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.2991 34.8216 17.2991 31.6709C17.2991 28.5203 20.1717 26.0166 23.7259 26.0166C27.308 26.0166 30.1626 28.4935 30.1526 31.6709C30.1426 34.8483 27.308 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.8911 34.8216 40.8911 31.6709C40.8911 28.5203 43.7636 26.0166 47.3178 26.0166C50.9 26.0166 53.7545 28.4935 53.7446 31.6709C53.7346 34.8483 50.9 37.3253 47.3178 37.3253Z" fill="#5865F2"/>
              </svg>
              Discord
            </a>
          </div>
        </div>

        <div className="faq-header">
          <h1 className="faq-title">❓ Frequently Asked Questions ❓</h1>
          <p className="faq-subtitle">Everything you need to know about Doge Of The Day!</p>
        </div>

        <div className="faq-content">
          <div className="faq-section win98-bevel-inset">
            <h2 className="section-title">
              <img src="/doge.png" alt="Doge" style={{ height: '24px', width: 'auto', verticalAlign: 'middle', marginRight: '8px' }} />
              What is Doge Of The Day?
            </h2>
            <div className="faq-answer">
              <p>Doge Of The Day is a global chatroom where users pay 1 DOGE (1 Credit) to send messages. Every day, the 3 most upvoted messages win a portion of the total pool of DOGE spent sending messages during that 24-hour period.</p>
              <p>Think of it as a combination of old-school IRC chatrooms except there's cryptocurrency rewards. Much chat, very wow!</p>
            </div>
          </div>

          <div className="faq-section win98-bevel-inset">
            <h2 className="section-title">💰 How Does the Credit System Work?</h2>
            <div className="faq-answer">
              <ul>
                <li><strong>1 Credit ≈ 1 DOGE of prize pool</strong> - Each credit represents 1 DOGE that can be paid out in daily prizes.</li>
                <li><strong>Standard Deposit:</strong> Currently set so you deposit a bit more DOGE (e.g. 25.5 DOGE) and receive 20 Credits. This helps cover network & processor fees while still funding the full prize pool.</li>
                <li><strong>Message Cost:</strong> 1 Credit per message</li>
                <li><strong>Deposit Process:</strong> Click "Deposit" button, pay via NOWPayments, receive credits automatically</li>
                <li>Your credits are displayed in the header and update in real-time</li>
              </ul>
            </div>
          </div>

          <div className="faq-section win98-bevel-inset">
            <h2 className="section-title">🏆 Daily Contest & Reward Structure</h2>
            <div className="faq-answer">
              <p><strong>When:</strong> Winners are crowned every day at midnight UTC</p>
              <p><strong>How:</strong> Messages are ranked by upvotes received during the 24-hour period</p>
              <p><strong>Reward Distribution:</strong></p>
              <div className="reward-structure">
                <div className="reward-tier">
                  <span className="tier-rank">🥇 1st Place</span>
                  <span className="tier-percentage">60% of total pool</span>
                </div>
                <div className="reward-tier">
                  <span className="tier-rank">🥈 2nd Place</span>
                  <span className="tier-percentage">25% of total pool</span>
                </div>
                <div className="reward-tier">
                  <span className="tier-rank">🥉 3rd Place</span>
                  <span className="tier-percentage">15% of total pool</span>
                </div>
              </div>
              <p className="reward-note"><strong>Note:</strong> Only the top 3 most upvoted messages win prizes. This ensures larger payouts that won't be eaten up by processing fees. 100% of collected DOGE is distributed! No house edge.</p>
              <p className="reward-note" style={{ marginTop: '10px', fontSize: '0.9rem' }}>
                <strong>💡 Small Payouts:</strong> If a prize is below NOWPayments' minimum, the system automatically accumulates multiple wins to your address. You'll receive all your winnings - they may just be combined and sent together!
              </p>
            </div>
          </div>

          <div className="faq-section win98-bevel-inset">
            <h2 className="section-title">⬆️ How Do Upvotes Work?</h2>
            <div className="faq-answer">
              <ul>
                <li>Anyone can upvote messages they like</li>
                <li><strong>Important:</strong> You must have made at least 1 successful deposit to upvote (prevents bot accounts)</li>
                <li>Each user can only upvote a message once</li>
                <li>Upvotes determine daily contest rankings</li>
                <li>More upvotes = higher rank = bigger prize!</li>
              </ul>
            </div>
          </div>

          <div className="faq-section win98-bevel-inset">
            <h2 className="section-title">💎 What is the Doge Pool?</h2>
            <div className="faq-answer">
              <p>The Doge Pool shows the current day's prize pool in real-time! Every time someone sends a message, the pool grows by 1 DOGE.</p>
              <p>You can see:</p>
              <ul>
                <li>Total prize pool (all DOGE collected today)</li>
                <li>Number of messages sent today</li>
                <li>The current leader (message with most upvotes so far)</li>
              </ul>
              <p>Watch it grow throughout the day and compete to be at the top!</p>
            </div>
          </div>

          <div className="faq-section win98-bevel-inset">
            <h2 className="section-title">👑 What Are Badges?</h2>
            <div className="faq-answer">
              <p>Badges are special achievements displayed on your profile:</p>
              <ul>
                <li><strong>Top Winner Badge (👑):</strong> Awarded to the user with the highest upvoted daily winner message from the last 7 days</li>
                <li>Badges update automatically after each daily payout</li>
                <li>Show off your achievements on your profile!</li>
              </ul>
            </div>
          </div>

          <div className="faq-section win98-bevel-inset">
            <h2 className="section-title">💳 Payment & Deposits</h2>
            <div className="faq-answer">
              <ul>
                <li><strong>Payment Provider:</strong> NOWPayments (secure cryptocurrency payment processor)</li>
                <li><strong>Standard Deposit:</strong> The deposit modal will show the exact DOGE amount (including estimated fees) and how many Credits you'll receive.</li>
                <li><strong>Deposit Process:</strong> Click \"Deposit\", scan the QR code or copy the address, send the shown DOGE amount</li>
                <li><strong>Confirmation:</strong> Credits are added automatically when payment is confirmed (usually a few minutes)</li>
                <li><strong>Payout Address:</strong> Set your DOGE wallet address in Settings to receive contest winnings</li>
              </ul>
            </div>
          </div>

          <div className="faq-section win98-bevel-inset">
            <h2 className="section-title">💰 Payouts & Winnings</h2>
            <div className="faq-answer">
              <p><strong>How Payouts Work:</strong></p>
              <ul>
                <li>Winners are paid out automatically at midnight UTC each day</li>
                <li>Payouts are sent directly to the DOGE address you set in Settings</li>
                <li>You can view your payout history in the Settings page</li>
              </ul>
              <p><strong>Minimum Payout Amounts:</strong></p>
              <ul>
                <li>NOWPayments requires a minimum amount for payouts (typically around 1 DOGE)</li>
                <li><strong>Automatic Accumulation:</strong> If your prize is below the minimum, the system will automatically accumulate multiple small wins to your address</li>
                <li>If you win multiple times with small amounts, they'll be combined and sent once the total reaches the minimum</li>
                <li>If a payout is still too small even after accumulation, it will be recorded for manual processing (you'll still receive it, just may take a bit longer)</li>
              </ul>
              <p><strong>Address Change Restrictions:</strong></p>
              <ul>
                <li>For security, address changes are locked 1 hour before and after payout time (midnight UTC)</li>
                <li>This means you cannot change your payout address from 11:00 PM UTC to 12:59 AM UTC</li>
                <li>This prevents last-second address manipulation and ensures payouts go to the correct address</li>
                <li>You can change your address at any other time - just plan ahead if you need to update it near payout time!</li>
              </ul>
            </div>
          </div>

          <div className="faq-section win98-bevel-inset">
            <h2 className="section-title">📊 Profile & Stats</h2>
            <div className="faq-answer">
              <p>Your profile shows:</p>
              <ul>
                <li><strong>Total Messages Sent:</strong> How many messages you've posted</li>
                <li><strong>Total Upvotes Received:</strong> Total upvotes on all your messages</li>
                <li><strong>Daily Wins:</strong> Number of times you've won a daily contest (1st place)</li>
                <li><strong>Member Since:</strong> When you joined Doge Of The Day</li>
                <li><strong>Badges:</strong> Special achievements you've earned</li>
              </ul>
              <p>Click any username to view their profile and stats!</p>
            </div>
          </div>

          <div className="faq-section win98-bevel-inset">
            <h2 className="section-title">🛡️ Security & Rules</h2>
            <div className="faq-answer">
              <ul>
                <li><strong>Upvote Restriction:</strong> Must deposit at least once to upvote (prevents bot accounts)</li>
                <li><strong>One Upvote Per Message:</strong> Each user can only upvote a message once</li>
                <li><strong>Message Limits:</strong> 500 characters maximum per message</li>
                <li><strong>Password Security:</strong> Passwords are hashed and never stored in plain text</li>
                <li><strong>Wallet Address:</strong> Make sure your payout address is correct - you can update it in Settings</li>
              </ul>
            </div>
          </div>

          <div className="faq-section win98-bevel-inset">
            <h2 className="section-title">❓ Need More Help?</h2>
            <div className="faq-answer">
              <p>If you have questions or need assistance:</p>
              <ul>
                <li>Check the Settings page for account information</li>
                <li>View the Leaderboard to see top winners and best messages</li>
                <li>Check the Doge Puddle to see current contest status</li>
                <li>Make sure your wallet address is correct in Settings</li>
              </ul>
              <p><strong>Remember:</strong> Be respectful, have fun, and may the best messages win! 🐕💎</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;

